/**
 * Admin-side copy for the listing review page, kept pure so it can be read —
 * and tested — without mounting the page.
 */
// The realtor-facing wording in UNPUBLISH_COPY explains a hold in full
// sentences; the admin needs the same fact in half a clause. Any other
// system hide falls back to "Eqaya hid it".
const HOLD_IN_WORDS = {
  reverification: 'it needs re-verification',
  eac_standing: 'the agency has lost EAC standing',
  mandate_expired: 'the owner\'s mandate to sell has run out',
};

/**
 * What to tell the admin after a successful Mark verified. The server decides
 * whether the sign-off also published the listing (auto-publish) or parked it,
 * so the notice has to read the listing it hands back.
 */
export function signOffNotice(listing) {
  const status = listing?.status;
  if (status === 'published') return 'Verified and live';
  if (status === 'verified') return "Verified — awaiting the realtor's publish";
  if (status === 'unpublished' && listing?.unpublish_reason === 'eac_standing') {
    return "Verified but hidden: the agency's EAC standing is lapsed";
  }
  if (status === 'unpublished') return 'Verified but hidden from buyers';
  return 'Verified';
}

/**
 * The force-publish checkbox label. The admin payload does not expose the
 * agency's EAC standing, so force is always offered — the label names the hold
 * when one is known and stays honest about the unknown when it is not.
 */
export function forcePublishLabel(listing) {
  const reason = listing?.status === 'unpublished' ? listing?.unpublish_reason : null;
  // "manual" is the realtor's own hide: nothing to override, so it is not a
  // system hold and the generic wording applies.
  const known = reason && reason !== 'manual' ? (HOLD_IN_WORDS[reason] || 'Eqaya hid it') : null;
  return known
    ? `Force publish — buyers will see this listing even though ${known}. The realtor is notified.`
    : 'Force publish — override any hold (agency standing, re-verification). The realtor is notified.';
}
